(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !window.DesignMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-bespoke-header"] && !window.DesignMode) return;
  try {
    

    bespokePage.infor.init();
    APModal.instantiate();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--comp-bespoke-header')) {
                bespokePage.infor.init(event.target);
                APModal.instantiate();
            }
        });
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-custom-bottom-gotop"] && !window.DesignMode) return;
  try {
    
    commonUI.bottomPageTop();
    
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--custom-bottom-gotop')) {
                commonUI.bottomPageTop(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !window.DesignMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-best"] && !window.DesignMode) return;
  try {
    
    // console.log('shopify:section:load');
    pageMain.best.init();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--main-best')) {
                pageMain.best.init(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bg"] && !window.DesignMode) return;
  try {
    
    pageMain.blurEffect.init();
    
    if(Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--main-bg')) {
                pageMain.blurEffect.init(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-branding"] && !window.DesignMode) return;
  try {
    
    // console.log('shopify:section:load');
    pageMain.branding.init();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if(event.target.classList.contains('shopify-section-main--branding')) {
                pageMain.branding.init(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-kv"] && !window.DesignMode) return;
  try {
    
    // console.log('shopify:section:load');
    pageMain.aos.init(); // 제일 최상단컴포넌트에서 AOS 로드
    pageMain.keyVisual.init();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            pageMain.aos.init();
            if (event.target.classList.contains('shopify-section--main-kv')) {
                pageMain.keyVisual.init(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-new"] && !window.DesignMode) return;
  try {
    
    // console.log('shopify:section:load');
    pageMain.new.init();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.classList.contains('shopify-section--main-new')) {
                pageMain.new.init(event.target);
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-bespoke-lip-sleeping"] && !window.DesignMode) return;
  try {
    

    const shadeColorList = [
        {
            name: "Sweet Candy+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnesweetcandy_pc_int.png",
        },
        {
            name: "Sweet Candy+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodasweetcandy_pc_int.png",
        },
        {
            name: "Sweet Candy+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_gummybearsweetcandy_pc_int.png",
        },
        {
            name: "Sweet Candy+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_orangesweetcandy_pc_int.png",
        },
        {
            name: "Sweet Candy+Vanilla",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_sweetcandyvanilla_pc_int.png",
        },
        {
            name: "Sweet Candy+Chocolate",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolatesweetcandy_pc_int.png",
        },
        {
            name: "Gummy Bear+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodagummybear_pc_int.png",
        },
        {
            name: "Gummy Bear+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnegummybear_pc_int.png",
        },
        {
            name: "Blue Cream Soda+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodachampagne_pc_int.png",
        },
        {
            name: "Mint Choco+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnemint_pc_int.png",
        },
        {
            name: "Mint Choco+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodamint_pc_int.png",
        },
        {
            name: "Mint Choco+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_gummybearmint_pc_int.png",
        },
        {
            name: "Mint Choco+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_mintorange_pc_int.png",
        },
        {
            name: "Mint Choco+Vanilla",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_mintvanilla_pc_int.png",
        },
        {
            name: "Mint Choco+Chocolate",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolatemint_pc_int.png",
        },
        {
            name: "Orange+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_gummybearorange_pc_int.png",
        },
        {
            name: "Orange+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodaorange_pc_int.png",
        },
        {
            name: "Orange+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagneorange_pc_int.png",
        },
        {
            name: "Lemon+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnelemon_pc_int.png",
        },
        {
            name: "Lemon+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodalemon_pc_int.png",
        },
        {
            name: "Lemon+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_gummybearlemon_pc_int.png",
        },
        {
            name: "Lemon+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_lemonorange_pc_int.png",
        },
        {
            name: "Lemon+Vanilla",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_lemonvanilla_pc_int.png",
        },
        {
            name: "Lemon+Chocolate",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolatelemon_pc_int.png",
        },
        {
            name: "Lemon+Mint Choco",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_lemonmint_pc_int.png",
        },
        {
            name: "Lemon+Sweet Candy",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_lemonsweetcandy_pc_int.png",
        },
        {
            name: "Berry+Lemon",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrylemon_pc_int.png",
        },
        {
            name: "Sweet Candy+Mint Choco",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_mintsweetcandy_pc_int.png",
        },
        {
            name: "Berry+Sweet Candy",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrysweetcandy_pc_int.png",
        },
        {
            name: "Berry+Mint Choco",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrymint_pc_int.png",
        },
        {
            name: "Berry+Chocolate",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrychocolate_pc_int.png",
        },
        {
            name: "Berry+Vanilla",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berryvanilla_pc_int.png",
        },
        {
            name: "Berry+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berryorange_pc_int.png",
        },
        {
            name: "Berry+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrygummybear_pc_int.png",
        },
        {
            name: "Berry+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrybluecreamsoda_pc_int.png",
        },
        {
            name: "Berry+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_berrychampagne_pc_int.png",
        },
        {
            name: "Chocolate+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnechocolate_pc_int.png",
        },
        {
            name: "Chocolate+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodachocolate_pc_int.png",
        },
        {
            name: "Chocolate+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolategummybear_pc_int.png",
        },
        {
            name: "Chocolate+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolateorange_pc_int.png",
        },
        {
            name: "Chocolate+Vanilla",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_chocolatevanilla_pc_int.png",
        },
        {
            name: "Vanilla+Orange",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_orangevanilla_pc_int.png",
        },
        {
            name: "Vanilla+Gummy Bear",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_gummybearvanilla_pc_int.png",
        },
        {
            name: "Vanilla+Blue Cream Soda",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_bluecreamsodavanilla_pc_int.png",
        },
        {
            name: "Vanilla+Champagne",
            color: "https://cdn.shopify.com/s/files/1/0914/4877/0862/files/page_bespoke-lip-sleeping-mask_select_product_champagnevanilla_pc_int.png",
        },
    ];
    const shadeRootEl = document.querySelector(".ft-shades-bespoke");
    const shadeListEl = shadeRootEl.querySelector(".shade-list");
    let itemHtml = [];
    if (shadeColorList && shadeColorList.length > 1) {
        for (let i = 0; i < shadeColorList.length; i++) {
            itemHtml.push(
                `<li class="shade-list__item">
                    <button class="shade-list__colorchip" type="button" ap-click-area="BespokeLSM_Introduction" ap-click-name="Click - color chip" ap-click-data="${shadeColorList[i].name}">
                        <img class="colorchip_img" src="${shadeColorList[i].color}" alt="${shadeColorList[i].name}">
                        <span class="colorchip_name">${shadeColorList[i].name}</span>
                    </button>
                </li>`
            );
        }
        shadeListEl.innerHTML = itemHtml.join("");
    }

    selectColorChipsLip();
    playVideo();
    actionTab.actionStickyTab();
    actionTab.scene();

    const reviewSet = {
        msnry: null,
        popSwiper: null,
        _reviewList: null,
        stickyInner: document.querySelector(".bespoke-header__sticky"),
        filterTab: document.getElementById('review-filter-tab'),
        filterSort: document.getElementById('review-filter-sort'),
        reviewMasonry: function () {
            const bespokeReviewList = document.querySelector(".bespoke-review-wrap");
            const reviewItem = bespokeReviewList.querySelectorAll(".review-item");

            if (reviewItem.length > 0) {
                msnry = new Masonry(bespokeReviewList, {
                    itemSelector: ".review-item",
                    columnWidth: ".review-item",
                    percentPosition: true,
                    horizontalOrder: true,
                });
            }
        },
        reviewCall: function (page, callback) {
            // let config = {
            //     version: 1,
            //     apiName: "laneige/bespoke",
            //     method: method,
            //     params: {
            //         siteCd: "laneigekrko",
            //         start: start,
            //         end: pagePerCnt,
            //         sortFl: sort,
            //     },
            // };

            const pagePerCnt = 9;
            const pagePerGroup = 5;

            // 리뷰 데이터
            // 더미데이터 (kr환경 데이터와 동일일)
            const result = {
                "resultCode": "0000",
                "resultMsg": "정상 처리 되었습니다.",
                "data": {
                    "summary": {
                        "total": 42,
                        "avg": 4.9
                    },
                    "reviewList": [
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "687576843",
                            "cont": "Judy was great! The color that the computer suggested was to light so she choose 2 different shades to test. One matched me very well. I&#39;m very satisfied ",
                            "regDate": "2025.02.23 12:00",
                            "resoDate": "2025.02.23",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "M***************",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [
                                {
                                    "ord": 1,
                                    "file_path": "https://prd-bw-img.amorepacific.com/laneigekrko/2025/02/23/eebzuiaggq.jpg",
                                    "file_nm": "eebzuiaggq.jpg"
                                },
                                {
                                    "ord": 2,
                                    "file_path": "https://prd-bw-img.amorepacific.com/laneigekrko/2025/02/23/wkzybpgrzy.jpg",
                                    "file_nm": "wkzybpgrzy.jpg"
                                }
                            ],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "385503725",
                            "cont": "화알못이라 피부화장이라도 깔끔하게 하고 싶었는데 항상 팩트나 파운데이션 선택에 어려움이 있었어요. 컬러칩으로 제 얼굴에 맞는 컬러를 찾아주고 나중에 온라인으로도 살 수 있어서 넘 좋네요. 안내해주시는 분도 무척 친절해서 좋았습니다. ",
                            "regDate": "2024.04.28 19:38",
                            "resoDate": "2024.04.28",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "백**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "372515732",
                            "cont": "너무 친절하시고 화장을 자주하지 않는사람도 잘 알아들을 수 있도록 설명해주셨어요! 추천제품도 적어주셔서 예약서비스 마치고 구경하다가 하나 구매했습니다! 지연(?)선생님(혹은 Nana 선생님) 최고였어요!",
                            "regDate": "2024.04.27 16:57",
                            "resoDate": "2024.04.27",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "정**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "600545714",
                            "cont": "전문가분이 추천해주셔서 믿고삽니다♡",
                            "regDate": "2024.04.20 12:48",
                            "resoDate": "2024.04.20",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "서**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "607508711",
                            "cont": "체험해주시는 선생님이 친절하시고 톤에 맞게 잘 추천해주셔서 만족합니다\uD83E\uDEF6\uD83C\uDFFB",
                            "regDate": "2024.04.20 12:46",
                            "resoDate": "2024.04.20",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "전**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "776541707",
                            "cont": "I dont regret making an appointment here because they made the whole process so fun and matches my color instantly! I will definitely want to come back here!",
                            "regDate": "2024.03.26 11:32",
                            "resoDate": "2024.03.26",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "R**********",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "354553710",
                            "cont": "너무 친절하시고 저에게 맞는 톤을 잘 추천해주세요 재방문의사 완전 있습니다!",
                            "regDate": "2024.03.12 15:10",
                            "resoDate": "2024.03.12",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "정**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "692515704",
                            "cont": "100% amazing service !\nthe staff was amazing,really kind, spoke nice entlish and korean and answered all my questions ! i will definetly comeback when i can, thank you",
                            "regDate": "2024.03.11 14:35",
                            "resoDate": "2024.03.11",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "M*********",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "272540719",
                            "cont": "제가 민감성피부이고 맞는 화운데이션을 못 찾아서 한국방문하면서 꼭 해보고 싶었어요. 테스트해주시는 직원분도 너무 친절하시고 프로페셔널 하셔서 저에게 맞는 색상을 추천해주셔서 너무 좋았어요.:) 기억에 남을 경험이었어요. ",
                            "regDate": "2024.03.08 11:48",
                            "resoDate": "2024.03.08",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "E****************",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        }
                    ]
                }
            };

            if (result.resultCode == "0000") {
                //summary
                let summary = result.data.summary;
                // if (method == "review/list") {

                    $("#reviewTab").html(`Product Reviews (${summary.total})`);
                    $("#review_total").html(`${summary.total} Number of Customer Reviews`);
                    $("#review_avg").html(`${summary.avg.toFixed(1)} / 5.0`);
        
                    // 240207 별점 소수점 처리
                    const ratingStars = document.querySelector("[data-rate]");
                    const innerStar = ratingStars.querySelector(".rating-star--inner");
                    const dataRate = parseFloat(summary.avg.toFixed(1));
        
                    innerStar.style.width = dataRate * 20 + "%";

                // }

                const list = result.data.reviewList;
                this._reviewList = list;
        
                let html = '';
        
                for (let i = 0; i < list.length; i++) {
        
                    html += `<li class="review-item">
                        <div class="review-box">
        
                            <div class="review-box__header">
                                <span class="rating-score rating">
                                    <b class="a11y">Rating of ${list[i].avg}</b>
                                    <span class="rating-stars" aria-hidden="true">
                                        ${(() => {
                                            let ratingStars = '';
                                            for (let j = 0; j < 5; j++) {
                                                if (j < list[i].avg) {
                                                    ratingStars += '<span class="rating-star on"></span>';
                                                } else {
                                                    ratingStars += '<span class="rating-star off"></span>';
                                                }
                                            }
                                            return ratingStars;
                                        })()}
                                    </span>
                                </span>
                                <span class="review__product">${list[i].itemNm.replace("비스포크 네오", "").trim()}</span>
                            </div>
        
                            <div class="review__info">
                                <div class="review__user">${list[i].userNm}</div>
                                <time class="review__date" datetime="${list[i].resoDate}">${list[i].resoDate} 예약</time>
                            </div>
        
                            <div class="review__body">
                                <p class="review__text">${list[i].cont}</p>
                            </div>
                            
                            <ul class="review-buttons">
                                <li>
                                    <button class="review__open" type="button" data-review-idx="${i}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - Review Detail" ap-click-data="ViewMore"><span>See More</span></button>
                                </li>
                            </ul>
                            
                            <ul class="review-photo-list">
                                ${(() => {
                                    let reviewPhotoList = '';
                                    for (let j = 0; j < list[i].imageList.length; j++) {
                                        reviewPhotoList += `<li class="review-photo-item">
                                            <a href="#none" class="review-photo" data-review-idx="${i}" data-image-idx="${j}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - Review Details" ap-click-data="ImageClick">
                                                <img src="${list[i].imageList[j].file_path}" alt="리뷰 이미지"/>
                                            </a>
                                        </li>`;
                                    }
                                    return reviewPhotoList;
                                })()}
                            </ul>
        
                            ${(() => {
                                if (list[i].answ != null) {
                                    return `<div class="comment-wrap">
                                        <div class="review__info">
                                            <div class="review__user">라네즈 비스포크</div>
                                            <span class="review__date">${list[i].ansDate}</span>
                                        </div>
                                        <div class="comment-area">
                                            <p class="review__comment">${list[i].answ}</p>
                                        </div>
                                    </div>`;
                                } else {
                                    return '';
                                }
                            })()}
        
                        </div>
                    </li>
                    `;
        
                }
        
                $("#review_list").html(html);
                document.querySelector("#review_list").addEventListener('click', function(e) {
                    const detailBtn = e.target.closest('.review__open') || e.target.closest('.review-photo');
                    if (detailBtn) {
                        e.preventDefault();
                        const reviewIdx = detailBtn.dataset.reviewIdx;
                        const imageIdx = detailBtn.dataset.imageIdx;
                        reviewSet.openReviewLayer(reviewIdx, imageIdx);
                    }
                });
                this.buildPaging(summary.total, 1, 10, 5);
                this.reviewMasonry();
                if (callback && typeof callback === "function") {
                    callback();
                }
            }

        },
        buildPaging: function (count, curPage, entriesPerPage, pagesPerGroup) {

            document.querySelector("#pagination").removeEventListener('click', reviewSet.pagingEvent);
            
            const paging = new reviewSet.paging(count, curPage, entriesPerPage, pagesPerGroup);
            const pages = paging.pages();
            const prevGroupFirstPage = paging.prevGroupFirstPage();
            const nextGroupFirstPage = paging.nextGroupFirstPage();
            const lastPage = paging.lastPage();
            let html = "";
        
            if (prevGroupFirstPage >= 0) {
                html += `<button type="button" class="page page--prev" data-page="${prevGroupFirstPage}">
                        <span class="page__text"></span><span class="a11y">prev page</span>
                    </button>`;
            } else {
                html += `<button type="button" class="page page--prev is-disabled">
                        <span class="page__text"></span><span class="a11y">prev page</span>
                    </button>`;
            }
        
            for (let i = 0, l = pages.length; i < l; i++) {
                const p = pages[i];
                if (p === curPage) {
                    html += `<button type="button" class="page">
                            <span class="page__text current">${p}</span><span class="a11y">current page</span>
                        </button>`;
                } else {
                    html += `<button type="button" class="page" data-page="${p}">
                            <span class="page__text">${p}</span><span class="a11y">current page</span>
                        </button>`;
                }
            }
        
            if (nextGroupFirstPage > curPage && nextGroupFirstPage <= lastPage) {
                html += `<button type="button" class="page page--next" data-page="${nextGroupFirstPage}">
                        <span class="a11y">next page</span>
                    </button>`;
            } else {
                html += `<button type="button" class="page page--next is-disabled">
                        <span class="a11y">next page</span>
                    </button>`;
            }
        
            $("#pagination").html(html);

            document.querySelector("#pagination").addEventListener('click', reviewSet.pagingEvent);
        },
        paging: function (count, curPage, entriesPerPage, pagesPerGroup) {
            const lastPage = Math.ceil(count / entriesPerPage);
            const numberOfPages = Math.ceil(count / pagesPerGroup);
            const pageGroups = Math.ceil(numberOfPages / pagesPerGroup);
            const curGroup = Math.ceil((curPage * entriesPerPage) / (entriesPerPage * pagesPerGroup)) - 1;
            const startPage = curGroup * pagesPerGroup + 1;
        
            this.pages = function() {
                const arr = [];
                for (let i = 0, l = pagesPerGroup; i < l; i++) {
                    const pp = i + startPage;
                    if (pp <= lastPage) {
                        arr[i] = pp;
                    }
                }
                return arr;
            };
        
            this.prevGroupFirstPage = function() {
                return (curGroup - 1) * pagesPerGroup + 1;
            };
        
            this.nextGroupFirstPage = function() {
                return (curGroup + 1) * pagesPerGroup + 1;
            };
        
            this.isFirst = function() {
                return curPage == 1;
            };
            this.isLast = function() {
                return curPage == lastPage;
            };
            this.lastPage = function() {
                return lastPage;
            };
        },
        pagingEvent: function(e) {
            const pageBtn = e.target.closest('.page');
            if (pageBtn) {
                e.preventDefault();
                const page = pageBtn.dataset.page;
                reviewSet.reviewCall(page);
            }
        },
        openReviewLayer: function (idx, imageIndex) {
            // console.log(idx, imageIndex);
            if (document.querySelector("#bespokeReviewPopup")) {
                if (this.popSwiper) {
                    this.popSwiper.destroy();
                    this.popSwiper = null;
                }
                APModal.open("#bespokeReviewPopup", {
                    layerRootSelectorName: ".bespoke-review-popup", // 팝업 class
                    activeClass: "is-active", // active시 추가 될 class
                    on: {
                        layerOpenStart: function() {
                            // 231113 개발 요청 :: 해당 부분에 reivew data 삽입
                            let list = reviewSet._reviewList[idx];
                            if (list.imageList.length > 0) {
                                console.log("photo idx =" + idx);
                                $('#popup_imglistWrap').show();
                                $('#bespokeReviewPopup').addClass('with-photo');
                                let imgListHtml = '';
                                for (let i = 0; i < list.imageList.length; i++) {
                                    imgListHtml += `<div class="swiper-slide">
                                        <img src="${list.imageList[i].file_path}" alt="리뷰 이미지${i}" class="review-popup__photo"/>
                                    </div>`;
                                }
                                $('#popup_imglist').html(imgListHtml);
                            } else {
                                $('#bespokeReviewPopup').removeClass('with-photo');
                                $('#popup_imglistWrap').hide();
                            }
                            $('#popup_avg_txt').html('Rating of ' + list.avg);
        
                            let avgHtml = '';
                            for (let i = 0; i < 5; i++) {
                                if (i < list.avg) {
                                    avgHtml += '<span class="rating-star on"></span>';
                                } else {
                                    avgHtml += '<span class="rating-star off"></span>';
                                }
                            }
                            $('#popup_avg').html(avgHtml);
                            $('#popup_itemNm').html(list.itemNm.replace('BESPOKE NEO', '').trim());
                            $('#popup_userNm').html(list.userNm);
                            $('#popup_resoDate').html('Booking Date : ' + list.resoDate);
                            $('#popup_cont').html(list.cont);
                            if (list.answ != null) {
                                $('#popup_answNm').html('LANEIGE BESPOKE');
                                $('#popup_answDate').html(list.ansDate);
                                $('#popup_answ').html(list.answ);
                                $('#popup_answWrap').show();
                            } else {
                                $('#popup_answNm').html('');
                                $('#popup_answDate').html('');
                                $('#popup_answ').html('');
                                $('#popup_answWrap').hide();
                            }
        
                            // 리뷰 레이어 내 이미지 스와이퍼
                            // 비어있는 이미지 배열 생성
                            var image = [];
                            $(".popup-swiper .swiper-slide").each(function() {
                                // 현재 슬라이드에서 이미지의 src 속성을 가져와 배열에 추가
                                var src = $(this).find(".review-popup__photo").attr("src");
                                image.push(src);
                            });
        
                            if ($(".popup-swiper .swiper-slide").length > 0) {
                                popSwiper = new Swiper(".popup-swiper", {
                                    // 페이지네이션 커스텀 (슬라이드에서 가져온 이미지를 배열로 출력)
                                    pagination: {
                                        el: ".bespoke-review-popup .review-photo-list",
                                        clickable: true,
                                        renderBullet: function(index, className) {
                                            return (
                                                `<span class="review-photo-item ${className}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - ReviewImage" ap-click-data="ReviewPopup">
                                                    <img src="${image[index]}" alt="리뷰 이미지${index + 1}"/>
                                                </span>`
                                            );
                                        },
                                    },
                                    navigation: {
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                });
                                if (imageIndex > 0) {
                                    popSwiper.slideTo(imageIndex);
                                }
                            }
                            // 레이어 열리기 시작할 때 이벤트
                            console.log("layer open");
                            reviewSet.stickyInner.style.display = "none";
                        },
                        layerOpenEnd: function() {
                            // 레이어 열린 후 이벤트
                        },
                        layerCloseStart: function() {
                            // 레이어 닫히기 시작할 때 이벤트
                            console.log("layer close");
                            reviewSet.stickyInner.style.display = "block";
                            if (popSwiper) {
                                popSwiper.destroy();
                                popSwiper = null;
                            }
                        },
                        layerCloseEnd: function() {
                            // 레이어 닫힌 후 이벤트
                        },
                    },
                });
            }
        }
    }

    reviewSet.reviewCall();

    // filter - All, Photo Reviews 항목 선택시
    reviewSet.filterTab.addEventListener('custom-ui-dropdown:change', function(e) {
        alert('custom-ui-dropdown:change');
        console.log(e.detail);
        console.log(e.detail.index); // 선택된 항목의 index 값
        console.log(e.detail.element); // 선택된 요소 ('a' or 'input')
        console.log(e.detail.parentElement); // 선택된 li 요소
    });

    // filter - Newest, Highest Ratings 항목 선택시
    reviewSet.filterSort.addEventListener('custom-ui-dropdown:change', function(e) {
        alert('custom-ui-dropdown:change');
        console.log(e.detail);
        console.log(e.detail.index); // 선택된 항목의 index 값
        console.log(e.detail.element); // 선택된 요소 ('a' or 'input')
        console.log(e.detail.parentElement); // 선택된 li 요소
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-bespoke-neo"] && !window.DesignMode) return;
  try {
    

    const shadeColorList = [{
            name: "3C1",
            color: "#EDD2B9",
        },
        {
            name: "3C2",
            color: "#EED2BC",
        },
        {
            name: "3N1",
            color: "#EDD3B8",
        },
        {
            name: "3W1",
            color: "#EBD4B7",
        },
        {
            name: "3W2",
            color: "#EBD4B3",
        },

        {
            name: "5C1",
            color: "#ECCFB4",
        },
        {
            name: "5C2",
            color: "#EDCEB7",
        },
        {
            name: "5N1",
            color: "#EBCFB3",
        },
        {
            name: "5W1",
            color: "#E9D0B3",
        },
        {
            name: "5W2",
            color: "#EAD0AF",
        },

        {
            name: "7C1",
            color: "#EACBB0",
        },
        {
            name: "7C2",
            color: "#EBCBB3",
        },
        {
            name: "7N1",
            color: "#E9CCAF",
        },
        {
            name: "7W1",
            color: "#E7CCAE",
        },
        {
            name: "7W2",
            color: "#E8CCAA",
        },

        {
            name: "9C1",
            color: "#E9C7AB",
        },
        {
            name: "9C2",
            color: "#EAC7AE",
        },
        {
            name: "9N1",
            color: "#E7C8AB",
        },
        {
            name: "9W1",
            color: "#E6C9AA",
        },
        {
            name: "9W2",
            color: "#E6C9A6",
        },

        {
            name: "11C1",
            color: "#E7C4A7",
        },
        {
            name: "11C2",
            color: "#E8C3AA",
        },
        {
            name: "11N1",
            color: "#E5C5A7",
        },
        {
            name: "11W1",
            color: "#E4C5A6",
        },
        {
            name: "11W2",
            color: "#E5C5A2",
        },

        {
            name: "13C1",
            color: "#E5C1A4",
        },
        {
            name: "13C2",
            color: "#E6C1A7",
        },
        {
            name: "13N1",
            color: "#E4C2A3",
        },
        {
            name: "13W1",
            color: "#E3C2A2",
        },
        {
            name: "13W2",
            color: "#E3C29E",
        },

        {
            name: "17C1",
            color: "#E3BEA1",
        },
        {
            name: "17C2",
            color: "#E4BEA4",
        },
        {
            name: "17N1",
            color: "#E2BFA0",
        },
        {
            name: "17W1",
            color: "#E1BF9E",
        },
        {
            name: "17W2",
            color: "#E2BF9A",
        },
        {
            name: "19C1",
            color: "#E1BC9E",
        },
        {
            name: "19C2",
            color: "#E2BCA1",
        },
        {
            name: "19N1",
            color: "#E0BC9D",
        },
        {
            name: "19W1",
            color: "#E0BD9B",
        },
        {
            name: "19W2",
            color: "#E1BD97",
        },
        {
            name: "21C1",
            color: "#DEB89B",
        },
        {
            name: "21C2",
            color: "#DFB89E",
        },
        {
            name: "21N1",
            color: "#DEB999",
        },
        {
            name: "21W1",
            color: "#DDB997",
        },
        {
            name: "21W2",
            color: "#DEB993",
        },
        {
            name: "21.5C1",
            color: "#DCB697",
        },
        {
            name: "21.5C2",
            color: "#DCB59A",
        },
        {
            name: "21.5N1",
            color: "#DCB696",
        },
        {
            name: "21.5W1",
            color: "#DCB694",
        },
        {
            name: "21.5W2",
            color: "#DCB68F",
        },
        {
            name: "22C1",
            color: "#DAB394",
        },
        {
            name: "22C2",
            color: "#DAB297",
        },
        {
            name: "22N1",
            color: "#D9B392",
        },
        {
            name: "22W1",
            color: "#DAB390",
        },
        {
            name: "22W2",
            color: "#DBB38C",
        },
        {
            name: "22.5C1",
            color: "#D7B091",
        },
        {
            name: "22.5C2",
            color: "#D8AF94",
        },
        {
            name: "22.5N1",
            color: "#D7B08F",
        },
        {
            name: "22.5W1",
            color: "#D8B08C",
        },
        {
            name: "22.5W2",
            color: "#D9B088",
        },
        {
            name: "23C1",
            color: "#D5AD8E",
        },
        {
            name: "23C2",
            color: "#D5AC91",
        },
        {
            name: "23N1",
            color: "#D5AD8C",
        },
        {
            name: "23W1",
            color: "#D6AD89",
        },
        {
            name: "23W2",
            color: "#D7AD85",
        },
        {
            name: "24C1",
            color: "#D3AB8C",
        },
        {
            name: "24C2",
            color: "#D4AA8F",
        },
        {
            name: "24N1",
            color: "#D3AB89",
        },
        {
            name: "24W1",
            color: "#D4AA86",
        },
        {
            name: "24W2",
            color: "#D5AA82",
        },
        {
            name: "25C1",
            color: "#D1A98A",
        },
        {
            name: "25C2",
            color: "#D2A88D",
        },
        {
            name: "25N1",
            color: "#D2A987",
        },
        {
            name: "25W1",
            color: "#D3A884",
        },
        {
            name: "25W2",
            color: "#D4A880",
        },
        {
            name: "26C1",
            color: "#D0A788",
        },
        {
            name: "26C2",
            color: "#D0A68B",
        },
        {
            name: "26N1",
            color: "#D0A785",
        },
        {
            name: "26W1",
            color: "#D2A682",
        },
        {
            name: "26W2",
            color: "#D2A67E",
        },
        {
            name: "27C1",
            color: "#CEA586",
        },
        {
            name: "27C2",
            color: "#CEA489",
        },
        {
            name: "27N1",
            color: "#CFA583",
        },
        {
            name: "27W1",
            color: "#D0A480",
        },
        {
            name: "27W2",
            color: "#D1A47B",
        },
        {
            name: "28C1",
            color: "#CCA384",
        },
        {
            name: "28C2",
            color: "#CDA286",
        },
        {
            name: "28N1",
            color: "#CDA381",
        },
        {
            name: "28W1",
            color: "#CEA27D",
        },
        {
            name: "28W2",
            color: "#CFA279",
        },
        {
            name: "29C1",
            color: "#CAA081",
        },
        {
            name: "29C2",
            color: "#CAA084",
        },
        {
            name: "29N1",
            color: "#CBA07E",
        },
        {
            name: "29W1",
            color: "#CCA07B",
        },
        {
            name: "29W2",
            color: "#CDA076",
        },
        {
            name: "30C1",
            color: "#C79E7E",
        },
        {
            name: "30C2",
            color: "#C89D81",
        },
        {
            name: "30N1",
            color: "#C89E7B",
        },
        {
            name: "30W1",
            color: "#CA9D78",
        },
        {
            name: "30W2",
            color: "#CB9D74",
        },
        {
            name: "31C1",
            color: "#C49A7B",
        },
        {
            name: "31C2",
            color: "#C59A7E",
        },
        {
            name: "31N1",
            color: "#C59A78",
        },
        {
            name: "31W1",
            color: "#C79A74",
        },
        {
            name: "31W2",
            color: "#C89A70",
        },
        {
            name: "32C1",
            color: "#C09777",
        },
        {
            name: "32C2",
            color: "#C1967A",
        },
        {
            name: "32N1",
            color: "#C29674",
        },
        {
            name: "32W1",
            color: "#C39670",
        },
        {
            name: "32W2",
            color: "#C4966C",
        },
        {
            name: "33C1",
            color: "#BC9273",
        },
        {
            name: "33C2",
            color: "#BD9276",
        },
        {
            name: "33N1",
            color: "#BD9270",
        },
        {
            name: "33W1",
            color: "#BF926C",
        },
        {
            name: "33W2",
            color: "#C09268",
        },
        {
            name: "34C1",
            color: "#B88E6F",
        },
        {
            name: "34C2",
            color: "#B98D72",
        },
        {
            name: "34N1",
            color: "#B98E6C",
        },
        {
            name: "34W1",
            color: "#BB8D68",
        },
        {
            name: "34W2",
            color: "#BC8D63",
        },
        {
            name: "35C1",
            color: "#B4896B",
        },
        {
            name: "35C2",
            color: "#B4896E",
        },
        {
            name: "35N1",
            color: "#B58968",
        },
        {
            name: "35W1",
            color: "#B78863",
        },
        {
            name: "35W2",
            color: "#B8885F",
        },
        {
            name: "36C1",
            color: "#B08567",
        },
        {
            name: "36C2",
            color: "#B0846A",
        },
        {
            name: "36N1",
            color: "#B18464",
        },
        {
            name: "36W1",
            color: "#B38460",
        },
        {
            name: "36W2",
            color: "#B3845C",
        },
        {
            name: "37C1",
            color: "#AB8063",
        },
        {
            name: "37C2",
            color: "#AC8066",
        },
        {
            name: "37N1",
            color: "#AC8060",
        },
        {
            name: "37W1",
            color: "#AF7F5C",
        },
        {
            name: "37W2",
            color: "#AF7F58",
        },
        {
            name: "38C1",
            color: "#A77C60",
        },
        {
            name: "38C2",
            color: "#A77B63",
        },
        {
            name: "38N1",
            color: "#A87C5D",
        },
        {
            name: "38W1",
            color: "#AA7B59",
        },
        {
            name: "38W2",
            color: "#AB7B55",
        },
        {
            name: "39C1",
            color: "#A3775D",
        },
        {
            name: "39C2",
            color: "#A3775F",
        },
        {
            name: "39N1",
            color: "#A3775A",
        },
        {
            name: "39W1",
            color: "#A57756",
        },
        {
            name: "39W2",
            color: "#A67752",
        },
        {
            name: "40C1",
            color: "#9E7359",
        },
        {
            name: "40C2",
            color: "#9F735C",
        },
        {
            name: "40N1",
            color: "#9F7357",
        },
        {
            name: "40W1",
            color: "#A17253",
        },
        {
            name: "40W2",
            color: "#A1724F",
        },
    ];

    // console.log(shadeColorList.length)
    const shadeRootEl = document.querySelector(".ft-shades-bespoke");
    const shadeListEl = shadeRootEl.querySelector(".shade-list");
    let itemHtml = [];
    if (shadeColorList && shadeColorList.length > 1) {
        for (let i = 0; i < shadeColorList.length; i++) {
            itemHtml.push(`<li class="shade-list__item">
                <button class="shade-list__colorchip" type="button" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - color chip" ap-click-data="${shadeColorList[i].name}" style="background-color: ${shadeColorList[i].color}">
                    <span class="colorchip_name">${shadeColorList[i].name}</span>
                </button>
            </li>`);
        }
        shadeListEl.innerHTML = itemHtml.join("");
    }

    selectColorChips();
    playVideo();
    actionTab.actionStickyTab();
    actionTab.scene();

    const reviewSet = {
        msnry: null,
        popSwiper: null,
        _reviewList: null,
        stickyInner: document.querySelector(".bespoke-header__sticky"),
        filterTab: document.getElementById('review-filter-tab'),
        filterSort: document.getElementById('review-filter-sort'),
        reviewMasonry: function () {
            const bespokeReviewList = document.querySelector(".bespoke-review-wrap");
            const reviewItem = bespokeReviewList.querySelectorAll(".review-item");

            if (reviewItem.length > 0) {
                msnry = new Masonry(bespokeReviewList, {
                    itemSelector: ".review-item",
                    columnWidth: ".review-item",
                    percentPosition: true,
                    horizontalOrder: true,
                });
            }
        },
        reviewCall: function (page, callback) {
            // let config = {
            //     version: 1,
            //     apiName: "laneige/bespoke",
            //     method: method,
            //     params: {
            //         siteCd: "laneigekrko",
            //         start: start,
            //         end: pagePerCnt,
            //         sortFl: sort,
            //     },
            // };

            const pagePerCnt = 9;
            const pagePerGroup = 5;

            // 리뷰 데이터
            // 더미데이터 (kr환경 데이터와 동일일)
            const result = {
                "resultCode": "0000",
                "resultMsg": "정상 처리 되었습니다.",
                "data": {
                    "summary": {
                        "total": 42,
                        "avg": 4.9
                    },
                    "reviewList": [
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "687576843",
                            "cont": "Judy was great! The color that the computer suggested was to light so she choose 2 different shades to test. One matched me very well. I&#39;m very satisfied ",
                            "regDate": "2025.02.23 12:00",
                            "resoDate": "2025.02.23",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "M***************",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [
                                {
                                    "ord": 1,
                                    "file_path": "https://prd-bw-img.amorepacific.com/laneigekrko/2025/02/23/eebzuiaggq.jpg",
                                    "file_nm": "eebzuiaggq.jpg"
                                },
                                {
                                    "ord": 2,
                                    "file_path": "https://prd-bw-img.amorepacific.com/laneigekrko/2025/02/23/wkzybpgrzy.jpg",
                                    "file_nm": "wkzybpgrzy.jpg"
                                }
                            ],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "385503725",
                            "cont": "화알못이라 피부화장이라도 깔끔하게 하고 싶었는데 항상 팩트나 파운데이션 선택에 어려움이 있었어요. 컬러칩으로 제 얼굴에 맞는 컬러를 찾아주고 나중에 온라인으로도 살 수 있어서 넘 좋네요. 안내해주시는 분도 무척 친절해서 좋았습니다. ",
                            "regDate": "2024.04.28 19:38",
                            "resoDate": "2024.04.28",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "백**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "372515732",
                            "cont": "너무 친절하시고 화장을 자주하지 않는사람도 잘 알아들을 수 있도록 설명해주셨어요! 추천제품도 적어주셔서 예약서비스 마치고 구경하다가 하나 구매했습니다! 지연(?)선생님(혹은 Nana 선생님) 최고였어요!",
                            "regDate": "2024.04.27 16:57",
                            "resoDate": "2024.04.27",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "정**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "600545714",
                            "cont": "전문가분이 추천해주셔서 믿고삽니다♡",
                            "regDate": "2024.04.20 12:48",
                            "resoDate": "2024.04.20",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "서**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "607508711",
                            "cont": "체험해주시는 선생님이 친절하시고 톤에 맞게 잘 추천해주셔서 만족합니다\uD83E\uDEF6\uD83C\uDFFB",
                            "regDate": "2024.04.20 12:46",
                            "resoDate": "2024.04.20",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "전**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "776541707",
                            "cont": "I dont regret making an appointment here because they made the whole process so fun and matches my color instantly! I will definitely want to come back here!",
                            "regDate": "2024.03.26 11:32",
                            "resoDate": "2024.03.26",
                            "itemCd": "0",
                            "itemNm": "비스포크 네오 쿠션 15g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "R**********",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "354553710",
                            "cont": "너무 친절하시고 저에게 맞는 톤을 잘 추천해주세요 재방문의사 완전 있습니다!",
                            "regDate": "2024.03.12 15:10",
                            "resoDate": "2024.03.12",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "정**",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "692515704",
                            "cont": "100% amazing service !\nthe staff was amazing,really kind, spoke nice entlish and korean and answered all my questions ! i will definetly comeback when i can, thank you",
                            "regDate": "2024.03.11 14:35",
                            "resoDate": "2024.03.11",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "M*********",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        },
                        {
                            "siteCd": "laneigekrko",
                            "uniqSeq": "272540719",
                            "cont": "제가 민감성피부이고 맞는 화운데이션을 못 찾아서 한국방문하면서 꼭 해보고 싶었어요. 테스트해주시는 직원분도 너무 친절하시고 프로페셔널 하셔서 저에게 맞는 색상을 추천해주셔서 너무 좋았어요.:) 기억에 남을 경험이었어요. ",
                            "regDate": "2024.03.08 11:48",
                            "resoDate": "2024.03.08",
                            "itemCd": "1",
                            "itemNm": "비스포크 네오 파운데이션 30g",
                            "answ": null,
                            "ansDate": null,
                            "userNm": "E****************",
                            "avg": 5,
                            "imgServerUrl": "https://prd-bw-img.amorepacific.com",
                            "imageList": [],
                            "prdClrCd1": null,
                            "prdClrCd2": null
                        }
                    ]
                }
            };

            if (result.resultCode == "0000") {
                //summary
                let summary = result.data.summary;
                // if (method == "review/list") {

                    $("#reviewTab").html(`Product Reviews (${summary.total})`);
                    $("#review_total").html(`${summary.total} Number of Customer Reviews`);
                    $("#review_avg").html(`${summary.avg.toFixed(1)} / 5.0`);
        
                    // 240207 별점 소수점 처리
                    const ratingStars = document.querySelector("[data-rate]");
                    const innerStar = ratingStars.querySelector(".rating-star--inner");
                    const dataRate = parseFloat(summary.avg.toFixed(1));
        
                    innerStar.style.width = dataRate * 20 + "%";

                // }

                const list = result.data.reviewList;
                this._reviewList = list;
        
                let html = '';
        
                for (let i = 0; i < list.length; i++) {
        
                    html += `<li class="review-item">
                        <div class="review-box">
        
                            <div class="review-box__header">
                                <span class="rating-score rating">
                                    <b class="a11y">Rating of ${list[i].avg}</b>
                                    <span class="rating-stars" aria-hidden="true">
                                        ${(() => {
                                            let ratingStars = '';
                                            for (let j = 0; j < 5; j++) {
                                                if (j < list[i].avg) {
                                                    ratingStars += '<span class="rating-star on"></span>';
                                                } else {
                                                    ratingStars += '<span class="rating-star off"></span>';
                                                }
                                            }
                                            return ratingStars;
                                        })()}
                                    </span>
                                </span>
                                <span class="review__product">${list[i].itemNm.replace("비스포크 네오", "").trim()}</span>
                            </div>
        
                            <div class="review__info">
                                <div class="review__user">${list[i].userNm}</div>
                                <time class="review__date" datetime="${list[i].resoDate}">${list[i].resoDate} 예약</time>
                            </div>
        
                            <div class="review__body">
                                <p class="review__text">${list[i].cont}</p>
                            </div>
                            
                            <ul class="review-buttons">
                                <li>
                                    <button class="review__open" type="button" data-review-idx="${i}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - Review Detail" ap-click-data="ViewMore"><span>See More</span></button>
                                </li>
                            </ul>
                            
                            <ul class="review-photo-list">
                                ${(() => {
                                    let reviewPhotoList = '';
                                    for (let j = 0; j < list[i].imageList.length; j++) {
                                        reviewPhotoList += `<li class="review-photo-item">
                                            <a href="#none" class="review-photo" data-review-idx="${i}" data-image-idx="${j}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - Review Details" ap-click-data="ImageClick">
                                                <img src="${list[i].imageList[j].file_path}" alt="리뷰 이미지"/>
                                            </a>
                                        </li>`;
                                    }
                                    return reviewPhotoList;
                                })()}
                            </ul>
        
                            ${(() => {
                                if (list[i].answ != null) {
                                    return `<div class="comment-wrap">
                                        <div class="review__info">
                                            <div class="review__user">라네즈 비스포크</div>
                                            <span class="review__date">${list[i].ansDate}</span>
                                        </div>
                                        <div class="comment-area">
                                            <p class="review__comment">${list[i].answ}</p>
                                        </div>
                                    </div>`;
                                } else {
                                    return '';
                                }
                            })()}
        
                        </div>
                    </li>
                    `;
        
                }
        
                $("#review_list").html(html);
                document.querySelector("#review_list").addEventListener('click', function(e) {
                    const detailBtn = e.target.closest('.review__open') || e.target.closest('.review-photo');
                    if (detailBtn) {
                        e.preventDefault();
                        const reviewIdx = detailBtn.dataset.reviewIdx;
                        const imageIdx = detailBtn.dataset.imageIdx;
                        reviewSet.openReviewLayer(reviewIdx, imageIdx);
                    }
                });
                this.buildPaging(summary.total, 1, 10, 5);
                this.reviewMasonry();
                if (callback && typeof callback === "function") {
                    callback();
                }
            }

        },
        buildPaging: function (count, curPage, entriesPerPage, pagesPerGroup) {

            document.querySelector("#pagination").removeEventListener('click', reviewSet.pagingEvent);
            
            const paging = new reviewSet.paging(count, curPage, entriesPerPage, pagesPerGroup);
            const pages = paging.pages();
            const prevGroupFirstPage = paging.prevGroupFirstPage();
            const nextGroupFirstPage = paging.nextGroupFirstPage();
            const lastPage = paging.lastPage();
            let html = "";
        
            if (prevGroupFirstPage >= 0) {
                html += `<button type="button" class="page page--prev" data-page="${prevGroupFirstPage}">
                        <span class="page__text"></span><span class="a11y">prev page</span>
                    </button>`;
            } else {
                html += `<button type="button" class="page page--prev is-disabled">
                        <span class="page__text"></span><span class="a11y">prev page</span>
                    </button>`;
            }
        
            for (let i = 0, l = pages.length; i < l; i++) {
                const p = pages[i];
                if (p === curPage) {
                    html += `<button type="button" class="page">
                            <span class="page__text current">${p}</span><span class="a11y">current page</span>
                        </button>`;
                } else {
                    html += `<button type="button" class="page" data-page="${p}">
                            <span class="page__text">${p}</span><span class="a11y">current page</span>
                        </button>`;
                }
            }
        
            if (nextGroupFirstPage > curPage && nextGroupFirstPage <= lastPage) {
                html += `<button type="button" class="page page--next" data-page="${nextGroupFirstPage}">
                        <span class="a11y">next page</span>
                    </button>`;
            } else {
                html += `<button type="button" class="page page--next is-disabled">
                        <span class="a11y">next page</span>
                    </button>`;
            }
        
            $("#pagination").html(html);

            document.querySelector("#pagination").addEventListener('click', reviewSet.pagingEvent);
        },
        paging: function (count, curPage, entriesPerPage, pagesPerGroup) {
            const lastPage = Math.ceil(count / entriesPerPage);
            const numberOfPages = Math.ceil(count / pagesPerGroup);
            const pageGroups = Math.ceil(numberOfPages / pagesPerGroup);
            const curGroup = Math.ceil((curPage * entriesPerPage) / (entriesPerPage * pagesPerGroup)) - 1;
            const startPage = curGroup * pagesPerGroup + 1;
        
            this.pages = function() {
                const arr = [];
                for (let i = 0, l = pagesPerGroup; i < l; i++) {
                    const pp = i + startPage;
                    if (pp <= lastPage) {
                        arr[i] = pp;
                    }
                }
                return arr;
            };
        
            this.prevGroupFirstPage = function() {
                return (curGroup - 1) * pagesPerGroup + 1;
            };
        
            this.nextGroupFirstPage = function() {
                return (curGroup + 1) * pagesPerGroup + 1;
            };
        
            this.isFirst = function() {
                return curPage == 1;
            };
            this.isLast = function() {
                return curPage == lastPage;
            };
            this.lastPage = function() {
                return lastPage;
            };
        },
        pagingEvent: function(e) {
            const pageBtn = e.target.closest('.page');
            if (pageBtn) {
                e.preventDefault();
                const page = pageBtn.dataset.page;
                reviewSet.reviewCall(page);
            }
        },
        openReviewLayer: function (idx, imageIndex) {
            // console.log(idx, imageIndex);
            if (document.querySelector("#bespokeReviewPopup")) {
                if (this.popSwiper) {
                    this.popSwiper.destroy();
                    this.popSwiper = null;
                }
                APModal.open("#bespokeReviewPopup", {
                    layerRootSelectorName: ".bespoke-review-popup", // 팝업 class
                    activeClass: "is-active", // active시 추가 될 class
                    on: {
                        layerOpenStart: function() {
                            // 231113 개발 요청 :: 해당 부분에 reivew data 삽입
                            let list = reviewSet._reviewList[idx];
                            if (list.imageList.length > 0) {
                                console.log("photo idx =" + idx);
                                $('#popup_imglistWrap').show();
                                $('#bespokeReviewPopup').addClass('with-photo');
                                let imgListHtml = '';
                                for (let i = 0; i < list.imageList.length; i++) {
                                    imgListHtml += `<div class="swiper-slide">
                                        <img src="${list.imageList[i].file_path}" alt="리뷰 이미지${i}" class="review-popup__photo"/>
                                    </div>`;
                                }
                                $('#popup_imglist').html(imgListHtml);
                            } else {
                                $('#bespokeReviewPopup').removeClass('with-photo');
                                $('#popup_imglistWrap').hide();
                            }
                            $('#popup_avg_txt').html('Rating of ' + list.avg);
        
                            let avgHtml = '';
                            for (let i = 0; i < 5; i++) {
                                if (i < list.avg) {
                                    avgHtml += '<span class="rating-star on"></span>';
                                } else {
                                    avgHtml += '<span class="rating-star off"></span>';
                                }
                            }
                            $('#popup_avg').html(avgHtml);
                            $('#popup_itemNm').html(list.itemNm.replace('BESPOKE NEO', '').trim());
                            $('#popup_userNm').html(list.userNm);
                            $('#popup_resoDate').html('Booking Date : ' + list.resoDate);
                            $('#popup_cont').html(list.cont);
                            if (list.answ != null) {
                                $('#popup_answNm').html('LANEIGE BESPOKE');
                                $('#popup_answDate').html(list.ansDate);
                                $('#popup_answ').html(list.answ);
                                $('#popup_answWrap').show();
                            } else {
                                $('#popup_answNm').html('');
                                $('#popup_answDate').html('');
                                $('#popup_answ').html('');
                                $('#popup_answWrap').hide();
                            }
        
                            // 리뷰 레이어 내 이미지 스와이퍼
                            // 비어있는 이미지 배열 생성
                            var image = [];
                            $(".popup-swiper .swiper-slide").each(function() {
                                // 현재 슬라이드에서 이미지의 src 속성을 가져와 배열에 추가
                                var src = $(this).find(".review-popup__photo").attr("src");
                                image.push(src);
                            });
        
                            if ($(".popup-swiper .swiper-slide").length > 0) {
                                popSwiper = new Swiper(".popup-swiper", {
                                    // 페이지네이션 커스텀 (슬라이드에서 가져온 이미지를 배열로 출력)
                                    pagination: {
                                        el: ".bespoke-review-popup .review-photo-list",
                                        clickable: true,
                                        renderBullet: function(index, className) {
                                            return (
                                                `<span class="review-photo-item ${className}" ap-click-area="BespokeNeo_Introduction" ap-click-name="Click - ReviewImage" ap-click-data="ReviewPopup">
                                                    <img src="${image[index]}" alt="리뷰 이미지${index + 1}"/>
                                                </span>`
                                            );
                                        },
                                    },
                                    navigation: {
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                });
                                if (imageIndex > 0) {
                                    popSwiper.slideTo(imageIndex);
                                }
                            }
                            // 레이어 열리기 시작할 때 이벤트
                            console.log("layer open");
                            reviewSet.stickyInner.style.display = "none";
                        },
                        layerOpenEnd: function() {
                            // 레이어 열린 후 이벤트
                        },
                        layerCloseStart: function() {
                            // 레이어 닫히기 시작할 때 이벤트
                            console.log("layer close");
                            reviewSet.stickyInner.style.display = "block";
                            if (popSwiper) {
                                popSwiper.destroy();
                                popSwiper = null;
                            }
                        },
                        layerCloseEnd: function() {
                            // 레이어 닫힌 후 이벤트
                        },
                    },
                });
            }
        }
    }

    reviewSet.reviewCall();

    // filter - All, Photo Reviews 항목 선택시
    reviewSet.filterTab.addEventListener('custom-ui-dropdown:change', function(e) {
        alert('custom-ui-dropdown:change');
        console.log(e.detail);
        console.log(e.detail.index); // 선택된 항목의 index 값
        console.log(e.detail.element); // 선택된 요소 ('a' or 'input')
        console.log(e.detail.parentElement); // 선택된 li 요소
    });

    // filter - Newest, Highest Ratings 항목 선택시
    reviewSet.filterSort.addEventListener('custom-ui-dropdown:change', function(e) {
        alert('custom-ui-dropdown:change');
        console.log(e.detail);
        console.log(e.detail.index); // 선택된 항목의 index 값
        console.log(e.detail.element); // 선택된 요소 ('a' or 'input')
        console.log(e.detail.parentElement); // 선택된 li 요소
    });


  } catch(e) { console.error(e); }
})();
})();
